import Immutable from "immutable";
import { mapArrayToEntity } from "lib/data";

import * as schoolLinked from "lib/appserver/entityHeaders/schoolLinked";

const Notice = new Immutable.Record({
  ...schoolLinked.defaultProperties,
  subject: undefined,
  description: undefined,
  postedDate: undefined,
  icon: undefined
}, "Notice");
export default Notice;

Notice.fromAppserver = function buildNotice(rawNotice) {
  return Notice({
    subject: rawNotice.subject,
    description: rawNotice.description,
    postedDate: rawNotice.posted_date,
    icon: rawNotice.icon,
    ...schoolLinked.appserverAdapter(rawNotice)
  });
}

Notice.fromAppserverValueList = function buildNotice(valueList) {
  const rawNotice = mapArrayToEntity([
    "appserver_server_hostname",
    "appserver_server_id",
    "appserver_remote_school_id",
    "appserver_remote_entity_id",
    "id",
    "subject",
    "description",
    "posted_date",
    "icon"
  ], valueList);
  return Notice.fromAppserver(rawNotice);
}



// WEBPACK FOOTER //
// ./src/state/teachers/entities/Notice.js